import {useLayoutEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {usePrevious} from '../../../../../hooks/usePrevious';
import actions from '../../../../../actions/fortnite-game/lifetimePlays.actions';
import {getLifetimePlaysState} from '../../../../../selectors/fortnite-game/lifetimePlaysSelector';

import {WidgetDataParams} from '../types';
import {RootState} from '../../../../../index';
import {TimeScale, WidgetState} from '../../../../../types';
import {DefaultData} from '../../../../../reducers/fortnite-game/types';
import {LifetimePlaysDataItem} from '../../../../../reducers/fortnite-game/lifetimePlays.reducer';

export interface LifetimePlaysData extends DefaultData<LifetimePlaysDataItem> {
    overallVisits: number;
    mostVisited: {
        value: number;
        creativeIslandCode: string | null;
    };
}

export interface LifetimePlaysWidgetState extends Omit<WidgetState, 'data'> {
    data: {
        [TimeScale.DAILY]: LifetimePlaysData;
    };
}

const useLifetimePlaysData = (params: WidgetDataParams): LifetimePlaysWidgetState => {
    const {startDate, endDate, timeScale, selectedGames} = params;

    const dispatch = useDispatch();
    const prevParams = usePrevious<WidgetDataParams>(params);

    const {data, loading, error} = useSelector<RootState, LifetimePlaysWidgetState>(
        getLifetimePlaysState
    ).toJS();

    const fetchData = () => {
        const islands = selectedGames.map(({value}) => String(value));

        if (islands.length) {
            dispatch(
                actions.getLifetimePlays({
                    fromTs: startDate ? startDate.valueOf() : undefined,
                    toTs: endDate ? endDate.valueOf() : undefined,
                    timeScale,
                    islands
                })
            );
        }
    };

    useLayoutEffect(() => {
        if (prevParams) {
            fetchData();
        }
    }, [startDate, endDate, timeScale, selectedGames]);

    return {
        data,
        loading,
        error,
        reload: fetchData
    };
};

export default useLifetimePlaysData;
